import React from 'react';
import {Button, Chip, Divider, IconButton, Paper, Slide, Stack, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DirectionsIcon from '@mui/icons-material/Directions';
import Constants from "../../../../utils/constants";
import {dashboardHelper} from "../utils/dashboardHelper";
import HeureDebutChip from "../ui/HeureDebutChip.js";

const DashboardMapBottomSheet = ({tournee, open, onClose}) => {
    if (!tournee) return null;
    const equipeColor = dashboardHelper.getColorByEquipe(tournee.equipeName);

    return (
        <Slide direction="up" in={open} mountOnEnter unmountOnExit>
            <Paper
                elevation={6}
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    p: 3,
                    backgroundColor: 'white',
                    maxHeight: '60vh',
                    overflowY: 'auto'
                }}
            >
                <Stack spacing={2}>
                    {/* Header */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction={"row"} spacing={1} alignItems="center">
                            <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                                {tournee.libelle}
                            </Typography>
                            <HeureDebutChip heureDebut={tournee.heureDebut}/>
                        </Stack>

                        <IconButton onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Stack>

                    {/* Infos équipe et prestation */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="body2" sx={{color: equipeColor}}>
                            {tournee.equipeName}
                        </Typography>
                        <Chip label={tournee.prestation} size="small"/>
                    </Stack>

                    {/* KPIs */}
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Chip
                            label={`${tournee.totalBacsLaves} / ${tournee.totalALaver}`}
                            sx={{backgroundColor: Constants.COLOR_THEME_GREEN, color: 'white'}}
                            size="small"
                        />
                        {tournee.totalBacsImpossible > 0 && (
                            <Chip
                                label={`${tournee.totalBacsImpossible}`}
                                sx={{backgroundColor: Constants.COLOR_THEME_RED, color: 'white'}}
                                size="small"
                            />
                        )}
                        <Chip
                            label={`Productivité : ${tournee.productivite ?? 0} bacs/h`}
                            size="small"
                            variant="outlined"
                        />
                    </Stack>

                    <Divider/>

                    {/* Actions */}
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button startIcon={<VisibilityIcon/>} variant="outlined">
                            Voir conteneurs
                        </Button>
                        <Button startIcon={<DirectionsIcon/>} variant="outlined">
                            Voir trajet
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Slide>
    );
};

export default DashboardMapBottomSheet;
